
import ProductList from '@/components/ProductList'
import SearchVehicleResults from '@/components/SearchVehicleResults'
import SearchNoResults from '@/components/SearchNoResults'
import SearchVehiclePacks from '@/components/SearchVehiclePacks'
import licencePlateMixin from '@/mixins/licencePlateMixin'
import { activeTechnicalFiltersCount } from '@/utils/technicalFilters'
import { topBannerKind } from '@/utils/welcomeOffer'
import { clockChangeBannerFor } from '@/utils/clockChange'
import {
  isPlateCandidate,
  searchEmptyState,
  vehiclesForSearch,
} from '@/utils/searchResults'

export default {
  name: 'SearchOverlay',
  components: {
    ProductList,
    SearchVehicleResults,
    SearchNoResults,
    SearchVehiclePacks,
  },
  mixins: [licencePlateMixin],
  data() {
    return {
      vehicles: [],
      isLoading: false,
    }
  },
  computed: {
    query() {
      return String(this.$route.query.q || '').trim()
    },
    hasTechnicalFilters() {
      return activeTechnicalFiltersCount(this.$route.query) > 0
    },
    hasProducts() {
      return (this.$store.state.products?.length || 0) > 0
    },
    vehiclePacks() {
      return this.$store.state.search_vehicle_packs
    },
    showVehiclePacks() {
      return (
        !this.$store.state.loading_products &&
        this.hasProducts &&
        !this.isPlate &&
        this.vehiclePacks > 0
      )
    },
    relevantVehicles() {
      return vehiclesForSearch(this.vehicles, this.query, {
        hasProducts: true,
      })
    },
    resultsSettled() {
      return (
        !this.isLoading &&
        !this.$store.state.loading_products &&
        !this.$route.query.page &&
        !this.hasTechnicalFilters
      )
    },
    isPlate() {
      return (
        isPlateCandidate(this.query) && this.validateLicencePlate(this.query)
      )
    },
    emptyState() {
      if (!this.resultsSettled) return null
      return searchEmptyState({
        hasProducts: this.hasProducts,
        vehicles: this.vehicles,
        isPlate: this.isPlate,
        vehiclePacks: this.vehiclePacks,
      })
    },
    showSuggestions() {
      if (this.emptyState) return true
      return !this.isLoading && this.hasProducts && this.isLastPage
    },
    mainContainerStyle() {
      const baseStyle = 'top:0;min-height:100%;'
      const hasTopBanner =
        topBannerKind({
          clockChange: clockChangeBannerFor(
            this.$store.state,
            this.$i18n.locale
          ),
          operationBannerPhase: this.$store.getters.operation_banner_phase,
          operationSlug: this.$store.state.commercial_operation?.slug,
          manualBannerVisible: this.$store.getters.manual_banner_visible,
          welcomeOffer: this.$store.getters.welcome_offer_for_visitor,
          routeName: this.$route.name,
        }) !== null
      const paddingTop = this.$device.isMobile
        ? hasTopBanner
          ? '132px'
          : '100px'
        : hasTopBanner
        ? '107px'
        : '75px'
      return `background: linear-gradient(150deg, #ebeff3, #ffffff 60%) no-repeat; padding-top: ${paddingTop}; ${baseStyle}`
    },
    contentContainerStyle() {
      const maxWidth = this.$screen.width >= 1850 ? '1920px' : '1400px'
      return `max-width: ${maxWidth};`
    },
    isLastPage() {
      return (
        Math.ceil(
          this.$store.state.pagination.total /
            this.$store.state.pagination.limit
        ) === this.$store.state.pagination.page
      )
    },
  },

  watch: {
    '$route.query.q': function () {
      this.fetchVehicles()
    },
    immediate: false,
  },

  created() {
    this.fetchVehicles()
  },

  methods: {
    async fetchVehicles() {
      this.isLoading = true

      try {
        const results = await this.$vehicleService.fetchSiteSearchVehicles(
          this.$route.query.q
        )

        this.vehicles = results.data
      } catch (error) {
        this.vehicles = []
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
